import ReactDOM from "react-dom/client";
import App from "./app/App";
import reportWebVitals from "./reportWebVitals";
import "antd/dist/reset.css";
import "./index.css";
import { applyChartColorVars } from "./theme/chartColorVars";

applyChartColorVars();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);

// TODO: Integrate logging for these
reportWebVitals();
